import React from 'react'

export default function TravelAds() {
    return (
        <div id="amzn-assoc-ad-cfd5336a-14c8-4852-94f3-94a249f114a5"></div>
    )
}

